import {TFunction} from 'i18next';

import {SENIORITY_LEVELS, SeniorityLevel} from '../lib/constants';

const SENIORITY_LEVEL_SET = new Set<string>(SENIORITY_LEVELS);

export const isSeniorityLevel = (value: string): value is SeniorityLevel => SENIORITY_LEVEL_SET.has(value);

export const getSeniorityLevelLabel = (seniority: string, t: TFunction): string => {
  if (!seniority) {
    return '';
  }

  if (isSeniorityLevel(seniority)) {
    return String(t(seniority, {keyPrefix: 'shared.seniorityLevels'}));
  }

  return seniority;
};
